import { baseUrl } from "./chain_network/chain_network";

export default function myImageLoader({ src, width, quality }) {
  return src;
}
